/* unplugin-vue-components disabled */import { render } from "./RecList.vue?vue&type=template&id=6fc4bb50"
import script from "./RecList.vue?vue&type=script&lang=js"
export * from "./RecList.vue?vue&type=script&lang=js"

import "./RecList.vue?vue&type=style&index=0&id=6fc4bb50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__